import { type FunctionalComponent, h } from '@stencil/core';
import { ConversationalSearchLabelWithSection } from '../../../../conversational-search-partials/label-with-section/label-with-section';
import { eventDispatcherForFunctionalComponents } from '../../../../conversational-search-logic/utils/utils';
import { medaliaGenAiConfigurationObject } from '../../../../../../../utils/medalia-integration/medalia-configurations';
import { showMedaliaComponent } from '../../../../../../../utils/medalia-integration/medalia-integration';
import type { labelProviderInterface } from '../../../../../../LabelProviderInterface';
import EventEmitterComponent from '../../../../conversational-search-partials/event-emitter-component/event-emitter-component';

export interface IConversationalSearchFollowUpNotSatisfied {
  query: string;
  labelProvider: labelProviderInterface;
  country: string;
  language: string;
  conversationalSearchMedaliaFormId: string;
}

export const ConversationalSearchFollowUpNotSatisfied: FunctionalComponent<IConversationalSearchFollowUpNotSatisfied> = (props) => {
    const { query, labelProvider, country, language, conversationalSearchMedaliaFormId } = props;
    const introTextCta = labelProvider(
      'conversational.search.followup.not.satisfied.intro.feedback',
      'Feedback',
    );

    const introText = labelProvider(
      'conversational.search.followup.not.satisfied.intro',
      'I\'m sorry I couldn\'t provide better information this time. Please share your {1} to help me improve and let me know how I could have assisted better. ',
    );

    const outroText = labelProvider(
      'conversational.search.followup.not.satisfied.outro',
      'Feel free to {1} or continue your conversation here.',
    );

    const outroTextCta = labelProvider(
      'conversational.search.followup.not.satisfied.new.conversation',
      'start a new topic',
    );

    const medaliafallback = () =>
      eventDispatcherForFunctionalComponents(
        'conversational-search:medalia-fallback',
      );

    const onClickIntroAction = () => {
        showMedaliaComponent(
          conversationalSearchMedaliaFormId,
          medaliaGenAiConfigurationObject(country, language),
          medaliafallback,
        );
    };

    return (
      <section class="conversational-search-follow-up-not-satisfied">
        <div class="conversational-search-follow-up-not-satisfied__intro">
          <ConversationalSearchLabelWithSection text={introText}>
            <EventEmitterComponent eventName='conversational-search:ga-cta' isNotPropagatedForEnter={true} ctaName={'Feedback'} keyword={query}>
              <qds-inline-link
                onClick={() => onClickIntroAction()}
                onKeyDown={(e) => e.key === 'Enter' ? onClickIntroAction() : void 0}
              >
                {introTextCta}
              </qds-inline-link>
            </EventEmitterComponent>
          </ConversationalSearchLabelWithSection>
        </div>
        <ConversationalSearchLabelWithSection text={outroText}>
          <EventEmitterComponent eventName='conversational-search:user-new-conversation-trigger' isNotPropagatedForEnter={true}>
            <EventEmitterComponent EventEmitterComponent eventName='conversational-search:ga-cta' isNotPropagatedForEnter={true} ctaName={'start a new topic'} keyword={props.query}>
              <qds-inline-link>{outroTextCta}</qds-inline-link>
            </EventEmitterComponent>
          </EventEmitterComponent>
        </ConversationalSearchLabelWithSection>
      </section>
    );
};
